import React from 'react'
import AdviserProfile from '../AdviserProfile'
import MobileUnsupported from '../../../MobileUnsupported/MobileUnsupported'
import { connect } from 'react-redux'
import Spinner from '../../../../common/Spinners/Spinner'
import { actions, resetApprovalState } from './adviserProfileApprovalEditorContainerActions'
import { Row, Col } from 'react-bootstrap'
import history from '../../../../core/history'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class AdviserProfileEditorContainer extends React.Component {
  static propTypes = {
    adviserId: PropTypes.number.isRequired,
    pendingApprovalProfile: PropTypes.object.isRequired,
    publishedProfile: PropTypes.object.isRequired,
    fetchPendingApprovalProfile: PropTypes.func.isRequired,
    fetchPublishedProfile: PropTypes.func.isRequired,
    fetchContactNumberTypes: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    fetchedContactNumberTypes: PropTypes.bool.isRequired,
    fetchedBothProfiles: PropTypes.func.isRequired,
    profileApproved: PropTypes.bool.isRequired,
    profileRejected: PropTypes.bool.isRequired,
    edited: PropTypes.bool.isRequired,
    editingProfile: PropTypes.bool.isRequired,
    editAll: PropTypes.func.isRequired,
    submitProfile: PropTypes.func.isRequired,
    cancelAll: PropTypes.func.isRequired,
    stopAll: PropTypes.func.isRequired,
    containerIsValid: PropTypes.bool.isRequired,
    submittingProfile: PropTypes.bool.isRequired,
    submittedProfile: PropTypes.bool.isRequired,
    resetApprovalState: PropTypes.func.isRequired
  }

  componentDidUpdate (prevProps) {
    const { pendingApprovalProfile, publishedProfile } = prevProps
    if (pendingApprovalProfile.adviserId && this.props.pendingApprovalProfile.adviserId && publishedProfile.adviserId && this.props.publishedProfile.adviserId) {
      if (pendingApprovalProfile.adviserId === this.props.pendingApprovalProfile.adviserId && publishedProfile.adviserId === this.props.publishedProfile.adviserId) {
        this.props.fetchedBothProfiles()
      }
    }
    if (this.props.profileApproved) {
      history.push('/administration/pendingapprovalAdviserProfiles/')
    }
  }

  componentDidMount () {
    // Clear any submit/reject/approve state left over from the previous profile so reopening the
    // editor for the next adviser starts fresh - otherwise the prior "Profile rejected" message
    // and hidden Reject button persist into the next profile.
    this.props.resetApprovalState()
    this.props.fetchPendingApprovalProfile(this.props.adviserId)
    this.props.fetchPublishedProfile(this.props.adviserId)
    this.props.fetchContactNumberTypes()
  }

  render () {
    if (this.props.loading) {
      return <Spinner />
    }
    return <Row>
      <Col sm={12} md={12} lg={12} className="d-none d-md-block">
        <AdviserProfile
          pendingApprovalProfile={this.props.pendingApprovalProfile}
          publishedProfile={this.props.publishedProfile}
          cancelEditingProfile={this.props.cancelAll}
          submitProfile={this.props.submitProfile}
          submittedProfile={this.props.submittedProfile}
          submittingProfile={this.props.submittingProfile}
          editingProfile={this.props.editingProfile}
          editProfile={this.props.editAll}
          stopEditingProfile={this.props.stopAll}
          containerIsValid={this.props.containerIsValid}
          edited={this.props.edited}
        />
      </Col>
      <Col xs={12} className="d-block d-md-none">
        <MobileUnsupported />
      </Col>
    </Row>
  }
}

const mapStateToProps = ({ adviserProfileApprovalEditorContainer }) => {
  return {
    pendingApprovalProfile: adviserProfileApprovalEditorContainer.pendingApprovalProfile,
    publishedProfile: adviserProfileApprovalEditorContainer.publishedProfile,
    loading: adviserProfileApprovalEditorContainer.loading,
    fetchedContactNumberTypes: adviserProfileApprovalEditorContainer.fetchedContactNumberTypes,
    profileApproved: adviserProfileApprovalEditorContainer.promoteToApproved.submitted,
    profileRejected: adviserProfileApprovalEditorContainer.rejectProfile.submitted,
    editingProfile: adviserProfileApprovalEditorContainer.editingProfile,
    submittingProfile: adviserProfileApprovalEditorContainer.submittingProfile,
    submittedProfile: adviserProfileApprovalEditorContainer.submittedProfile,
    edited: adviserProfileApprovalEditorContainer.edited,
    containerIsValid: adviserProfileApprovalEditorContainer.containerIsValid
  }
}

const mapDispatchToProps = (dispatch) => {
  const { fetch, edit, submit } = actions
  return bindActionCreators({
    fetchPublishedProfile: fetch.publishedProfile.fetch,
    fetchPendingApprovalProfile: fetch.pendingApprovalProfile.fetch,
    fetchedBothProfiles: fetch.fetched,
    fetchContactNumberTypes: fetch.contactNumberTypes,
    editAll: edit.editAll,
    stopAll: edit.stopAll,
    cancelAll: edit.cancelAll,
    submitProfile: submit.submitPendingApprovalProfile,
    resetApprovalState: resetApprovalState
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AdviserProfileEditorContainer)
